interface Property {
  value: any
}

export const getPropsForUpdate = (
  prevProps: Record<string, Property>,
  newProps: Record<string, Property>
): Record<string, Property> =>
  Object.fromEntries(
    Object.entries(newProps).filter(
      ([key, value]) => key === 'configData' || !prevProps[key] || prevProps[key].value !== value
    )
  )
